<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
  methods: {
    generateUUID() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    }
  },
  created() {
      let identifier = localStorage.getItem('identifier');
      if (!identifier) {
        identifier = this.generateUUID();
        localStorage.setItem('identifier', this.generateUUID());
      }

      this.$api.registerAccess(identifier);
  }
}
</script>

<style lang="scss" scoped>
</style>
